import { createSelector } from '@ngrx/store'
import { onsiteReselector } from './onsite.reselector'
import { FilterGroup, filterStateSelector } from '../filters.era'
import { ProgramNodeDateMap } from 'globals/store/onsite.data'
import { DateSchedule } from 'globals/store/programs.data'
import { initializeMultiTimeline } from 'src/app/share/onsite.reselector.functions'
import { Dictionary } from '@ngrx/entity'
import { Performer, performersStateSelector } from '../performers.era'
import { fullProgramOrderReselector } from './programs.reselector'
import { filterTimeline } from 'globals/share/onsite.filtering'
import { convertFullMultiTimelineToSingleTimeline, initializeFullMultiTimeline } from 'globals/share/onsite.reselector.functions'
import { onsiteStateSelector } from '../onsite.era'
import { exhibitorsStateSelector } from '../exhibitors.era'
import { exhibitorStandsStateSelector } from '../exhibitor.stands.era'
import { assetsStateSelector } from '../assets.era'
import { programsStateSelector } from '../programs.era'
import { eventStateSelector } from '../events.era'


const onsiteFilters = createSelector(filterStateSelector, (state) => state.onsiteTimeline)
const dateId = createSelector(onsiteStateSelector, (state) => state.selectedDateString)
const exhibitors = createSelector(exhibitorsStateSelector, (state) => state.entities)
const performers = createSelector(performersStateSelector, (state) => state.entities)
const stands = createSelector(exhibitorStandsStateSelector, (state) => state.entities)
const assets = createSelector(assetsStateSelector, (state) => state.entities)
const programs = createSelector(programsStateSelector, (state) => state.entities)
const event = createSelector(eventStateSelector, (state) => state.event)

export const unfilteredMultiTimelineReselector = createSelector(
	onsiteReselector,
  dateId,
  performers,
  event,
	({ programNodesByDate }: { programNodesByDate: ProgramNodeDateMap }, dateId: string, performers: Dictionary<Performer>, event) => initializeMultiTimeline(programNodesByDate, dateId, performers, event.programOrder)
)

export const unfilteredFullMultiTimelineReselector = createSelector(
  onsiteReselector,
  performers,
  event,
	({ programNodesByDate }: { programNodesByDate: ProgramNodeDateMap }, performers: Dictionary<Performer>, event) => initializeFullMultiTimeline(programNodesByDate, performers, event?.programOrder)
)

export const fullMultiTimelineReselector = createSelector(
	unfilteredFullMultiTimelineReselector,
  onsiteFilters,
  exhibitors,
  stands,
  programs,
  (unfilteredMultiTimelines: DateSchedule[], onsiteFilters: FilterGroup, exhibitors, stands, programs) => {
    // console.log("fullMultiTimelineReselector")
    return filterTimeline(unfilteredMultiTimelines, onsiteFilters, true, exhibitors, 'oss', stands, programs)
  }
)

export const fullSingleTimelineReselector = createSelector(
  fullMultiTimelineReselector,
  assets,
  fullProgramOrderReselector,
	convertFullMultiTimelineToSingleTimeline
)